import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getUser } from './getUser';
export const getUserId = createSelector(getUser, get('user_id'));